import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';

import Poke from '../pages/Poke';



function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/pokedex" element={<Poke />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;